import React from 'react'
import { Document, Link, Page, Text, View, PDFDownloadLink, Image } from '@react-pdf/renderer'

import { capitalizeWords } from 'services/utils'

import styles from './config' 

const site_url                 = process.env.REACT_APP_SITE_URL
const business_name            = process.env.REACT_APP_BUSINESS_NAME
const business_address         = process.env.REACT_APP_BUSINESS_ADDRESS
const business_city_state      = process.env.REACT_APP_BUSINESS_CITY_STATE
const business_phone_number    = process.env.REACT_APP_BUSINESS_PHONE_NUMBER
const business_whatsapp_number = process.env.REACT_APP_BUSINESS_WHATSAPP_NUMBER
const business_zip             = process.env.REACT_APP_BUSINESS_ZIP

const business_packing_text    = process.env.REACT_APP_PARKING_TEXT  

const business_title           = process.env.REACT_APP_FOOTER_PDF_TITLE
const business_full_address    = process.env.REACT_APP_FOOTER_PDF_FULL_ADDRESS
const business_google_maps     = process.env.REACT_APP_SITE_GOOGLE_MAPS_LINK 


const getData = user => { 

    const nome          = user?.nomePessoa ? user?.nomePessoa : user?.nomePaciente
    const convenio      = capitalizeWords(user?.descricaoConvenio)
    const especialidade = capitalizeWords(user?.descricaoEspecialidade)
    const profissional  = capitalizeWords(user?.nomeProfissional)
    const data_hora     = `${user?.dataAgenda} - ${user?.horarioAgenda}`
    
    return [
        { text: "Dados do paciente"              , style: styles.subtitle },
        { text: `Nome: ${capitalizeWords(nome)}` , style: styles.text },
        { text: `CPF: ${user?.cpfPaciente}`      , style: styles.text },
        { text: `Convênio: ${convenio}`          , style: styles.text },
        { text: `Especialidade: ${especialidade}`, style: styles.text },
        { text: `Médico(a): ${profissional}`     , style: styles.text },
        { text: `Data/Hora: ${data_hora}h`       , style: styles.text }, 
    ]
}


export const ClinicaEndereco = [
    { text: `Endereço da ${business_name}:`        , style: styles.subtitle},
    { text: business_address                       , style: styles.text, adddress: true },
    { text: business_city_state                    , style: styles.text, adddress: true },
    { text: `Telefone: ${business_phone_number}`   , style: styles.text},
    { text: `WhatsApp: ${business_whatsapp_number}`, style: styles.text},
]

const footer = <View>
    <Text>{business_title}</Text>
    <Text>{business_full_address}</Text>
    <Text>CEP: {business_zip}</Text>
    <Text>Tel.: {business_phone_number}</Text>
    <Text>{site_url}</Text>

</View>

const observacoes = JSON.parse(process.env.REACT_APP_OBSERVACOES)
const importante  = JSON.parse(process.env.REACT_APP_IMPORTANTE)

const logo_src  = require(process.env.REACT_APP_ASSETS_LOGO)

const bg_src    = process.env.REACT_APP_ASSETS_BGLOGO ? require(process.env.REACT_APP_ASSETS_BGLOGO) : false

const ImageView = () => bg_src ? <Image style={styles.bgImage} src={bg_src}></Image> : ""

const PdfViewer = ({user}) => {
   
    const data = getData(user)
    
    return <>
        <Document>
            <Page size="A4" style={styles.page}>
                
                <View>

                    <View style={styles.header} >
                        <Image style={styles.image} src={logo_src}></Image>
                        <View>
                            <Text style={styles.title} >Agendamento</Text>
                        </View>
                    </View>
                
                    <View style={styles.body}>
                        
                        <View style={styles.section} >
                            {data.map( item => <Text style={item.style} key={item.text}>{item.text}</Text>)}
                        </View>
                        <View style={styles.section}>
                            {ClinicaEndereco.map( addres => <Text style={addres.style} key={addres.text}>{addres.text}</Text>)}
                            <Text style={styles.text} >
                                Google Maps: <Link style={{color: '#12195d'}}>{business_google_maps}</Link>
                            </Text>

                            
                        </View>
                        <View style={styles.section}>
                            <Text style={styles.text}>{business_packing_text}</Text>
                        </View>

                        <View style={styles.section}>
                            <View >
                                {observacoes.map( item => <Text key={item} style={styles.text}>{item}</Text>)}
                            </View>
                        </View>
                        <View style={{...styles.section, marginTop: 40}}>
                            {importante.map( item => <Text key={item} style={{fontSize: 14, margin: '3 7', fontWeight: '700', color: '#000'}}>{item}</Text>)}
                        </View>
                        
                        <ImageView />
                        
                    </View>
                    
                    
                </View>
            
                <View style={styles.footer}>
                    {footer}
                </View>
            </Page>
        </Document>
    </>
}

export const PdfDownload = props => {
    
    const {user, children, ...others} = props

    if (!user) return children 
    return <PDFDownloadLink {...others} document={<PdfViewer user={user} />} fileName='agendamento.pdf'>{children}</PDFDownloadLink>
}

export default PdfViewer